import { always } from "../../../../base/utils/ramdaEquivalents.utils";
import { makeObservableRouteDef } from "../../../../base/utils/routes.utils";
import PageInvitation from "./PageInvitation.page";

export const PageInvitationRouteDef = makeObservableRouteDef({
  identifier: 'invitation',
  urlFactory: always('invitation'),
  composeTitle: always('Invitation'),
  component: PageInvitation
})